import uuid from '@/js/common/Domain/Service/uuid';

export default function generateCardId(): string {
    return uuid();
}
